module.exports = __webpack_public_path__ + "static/media/22-009.ee841ae7.png";